/* eslint-disable import/prefer-default-export */
import { JobHardwareNodeV1 } from '@utils/api/cd4pe';

export type Node = JobHardwareNodeV1 & { selected?: boolean };
export type NodeList = Node[] | [];

export const compareNodes = (a: JobHardwareNodeV1, b: JobHardwareNodeV1) => {
  return a.name === b.name && a.peServerName === b.peServerName;
};
